import { ImageGallery } from './ImageGallery';
import { useCurrentMessage } from '@/contexts/CurrentMessageContext';
import Loader from './Loader';
import { OpenSCADViewer } from './OpenSCADViewer';
import { useIsLoading } from '@/services/messageService';
import { StarField } from '@/components/StarField';

export function ViewerSection() {
  const isLoading = useIsLoading();
  const { currentMessage: message } = useCurrentMessage();

  return (
    <div className="relative flex h-full w-full items-center justify-center bg-adam-neutral-700 overflow-hidden">
      {/* Star background */}
      <StarField starCount={200} speed={0.2} />

      {isLoading ? (
        <div className="relative h-full w-full">
          <Loader message="Generating model" />
        </div>
      ) : (
        <div className="relative z-10 flex h-full w-full flex-1 flex-col items-center justify-center gap-2">
          {message?.content.images && Array.isArray(message.content.images) && (
            <ImageGallery imageIds={message.content.images} />
          )}
          {message?.content.artifact?.code && <OpenSCADViewer />}
        </div>
      )}
    </div>
  );
}
